
import { throttle, debounce } from "../utilities/limiters.js";

const cursorGroup = document.getElementById( 'nu-cursor-group' );
const cursors = cursorGroup.querySelectorAll( '.nu-cursor' );
const mediaQuery = window.matchMedia( '(pointer: fine)' );

document.addEventListener( 'DOMContentLoaded', addMouseEvents );
mediaQuery.addEventListener( 'change', addMouseEvents );

function moveCursor( e ) {
    setPosition( e.clientX, e.clientY );
}

function addMouseEvents() {
    const throttledMouseMove = throttle( moveCursor, 10 );
    let listenerAdded = false;

    if ( mediaQuery.matches && !listenerAdded ) {
        window.addEventListener( 'mousemove', throttledMouseMove, { passive: true } );
        listenerAdded = true;
    } else if ( !mediaQuery.matches && listenerAdded ) {
        window.removeEventListener( 'mousemove', throttledMouseMove, { passive: true } );
        listenerAdded = false;
    }
}

function setPosition( x, y ) {
    cursors.forEach( cursor => {
        cursor.style.setProperty( 'transform', `translate(${x}px, ${y}px)` );
    } );
}
